import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShapes = () => {
  return (
    <g>
      <path d="m8 7.8437a3.5591 3.5591 0 1 0 -3.559-3.559 3.5632 3.5632 0 0 0 3.559 3.559zm0-5.6181a2.0591 2.0591 0 1 1 -2.059 2.0591 2.0616 2.0616 0 0 1 2.059-2.0591z" />
      <path d="m15.0635 8.6909h-5.0835a.75.75 0 0 0 -.75.75v5.0835a.75.75 0 0 0 .75.75h5.0835a.75.75 0 0 0 .75-.75v-5.0835a.75.75 0 0 0 -.75-.75zm-.75 5.0835h-3.5835v-3.5835h3.5835z" />
      <path d="m4.83 8.5312a.78.78 0 0 0 -1.2988 0l-3.244 5.6182a.75.75 0 0 0 .6494 1.125h6.4878a.75.75 0 0 0 .6494-1.125zm-2.5946 5.2432 1.9446-3.3682 1.9448 3.3682z" />
    </g>
  );
};

export default withIcon(IconShapes);
